import { h, ComponentChildren, ComponentChild } from "preact";
import { isComponentChildrenEmpty } from "services/utils";
import "./button.scss";

// https://mui.com/material-ui/react-button/

interface Props {
    children?: ComponentChildren;
    id?: string;
    disabled?: boolean;
    elevated?: boolean;
    onClick?: h.JSX.MouseEventHandler<HTMLElement>;
    variant?: "default" | "text" | "primary" | "outline";
    size?: "default" | "small" | "medium" | "large";
    //color?: string;
    class?: string;
    startIcon?: ComponentChild;
    endIcon?: ComponentChild;
}

export const Button = (props: Props) => {
    const css_variant = " " + (props.variant ?? "default");
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    const css_elevated = props.elevated && (!props.variant || props.variant !== "text") ? " elevated" : "";
    const css_icononly = isComponentChildrenEmpty(props.children) && (props.startIcon || props.endIcon) ? " icononly" : "";
    const css_classes = "btn" + css_variant + css_size + css_elevated + css_icononly + (!props.class ? "" : (" " + props.class));
    return (
        <button
            id={props.id}
            class={css_classes}
            disabled={props.disabled}
            onClick={props.onClick}>
            {
                props.startIcon
            }
            {
                props.children
            }
            {
                props.endIcon
            }
        </button>
    );
}

type LinkButtonProps = Props & {
    href?: string;
    target?: string;
};

export const LinkButton = (props: LinkButtonProps) => {
    const css_variant = (!props.variant || props.variant === "default") ? " contained" : (" " + props.variant);
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    const css_elevated = props.elevated && (!props.variant || props.variant !== "text") ? " elevated" : "";
    const css_icononly = isComponentChildrenEmpty(props.children) && (props.startIcon || props.endIcon) ? " icononly" : "";
    const css_classes = "btn" + css_variant + css_size + css_elevated + css_icononly + (!props.class ? "" : (" " + props.class));

    // todo: "disabled" styling not supported yet
    return (
        <a
            id={props.id}
            class={css_classes}
            href={props.disabled ? undefined : props.href}
            onClick={props.onClick}
            target={props.target}>
            {
                props.startIcon
            }
            {
                props.children
            }
            {
                props.endIcon
            }
        </a>
    );
}

// todo: iconbutton

// style={props.color ? { "--button-color": props.color } : undefined}
